/*
 * ANIME CRUSH — SCHEDULE TIME AND DAY HEADINGS
 *
 * The section renders every broadcast time in UTC with "UTC" written beside it,
 * and renders no day headings at all. Both of those are this script's job,
 * because both depend on where the reader is:
 *
 *   - 14:30 UTC is 23:30 in Tokyo, 07:30 in Los Angeles and 17:30 here. A
 *     server cannot know which one to print.
 *   - the boundary between Friday and Saturday is not one instant worldwide, so
 *     a server-rendered "Saturday" heading is wrong for a large part of the
 *     audience. Grouping has to happen after the zone is known.
 *
 * PROGRESSIVE, AND THE FALLBACK IS CORRECT RATHER THAN BROKEN. With no
 * JavaScript the page is a chronological list of UTC times labelled UTC, which
 * is a true answer. This only ever replaces true-but-inconvenient with
 * true-and-local.
 *
 * Intl.DateTimeFormat has been available everywhere for years, but a browser
 * without it - or a reader whose zone the browser will not report - keeps the
 * UTC rendering rather than getting a guess.
 */
(function () {
  'use strict';

  function supported() {
    try {
      return typeof Intl !== 'undefined' &&
             typeof Intl.DateTimeFormat === 'function' &&
             !!Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) { return false; }
  }

  function init() {
    var list = document.querySelector('[data-ac-sched-list]');
    if (!list) return;

    var rows = Array.prototype.slice.call(list.querySelectorAll('[data-ac-sched-at]'));
    if (!rows.length) return;
    if (!supported()) return;

    var zone;
    try { zone = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch (e) { return; }

    var timeFmt = new Intl.DateTimeFormat(undefined, {
      weekday: 'short', day: 'numeric', month: 'short',
      hour: '2-digit', minute: '2-digit'
    });
    var dayFmt = new Intl.DateTimeFormat(undefined, {
      weekday: 'long', day: 'numeric', month: 'long'
    });
    var shortFmt = new Intl.DateTimeFormat(undefined, { hour: '2-digit', minute: '2-digit' });

    /* Today and tomorrow, in the reader's zone, so the first headings can be
       words instead of dates. Compared on the formatted day, not on a
       subtraction, because that is the comparison that survives a DST shift. */
    var now = new Date();
    var todayKey = dayFmt.format(now);
    var tomorrowKey = dayFmt.format(new Date(now.getTime() + 86400000));

    var lastKey = null;

    rows.forEach(function (row) {
      var epoch = Number(row.getAttribute('data-ac-sched-at'));
      if (!epoch) return;
      var when = new Date(epoch * 1000);

      var timeEl = row.querySelector('[data-ac-sched-time]');
      var utcEl = row.querySelector('[data-ac-sched-utc]');
      var dayKey = dayFmt.format(when);

      if (timeEl) {
        /* Inside a day group the date is already in the heading, so the row only
           needs the clock. */
        timeEl.textContent = (dayKey === lastKey) ? shortFmt.format(when) : timeFmt.format(when);
      }
      /* The UTC marker has to go: it is no longer a UTC time. */
      if (utcEl && utcEl.parentNode) utcEl.parentNode.removeChild(utcEl);

      if (dayKey !== lastKey) {
        var label = dayKey === todayKey ? 'Today' :
                    dayKey === tomorrowKey ? 'Tomorrow' : dayKey;
        var head = document.createElement('li');
        head.className = 'AcSchedDay';
        /* A heading in the middle of an ordered list is not a list item of
           content, so it is taken out of the list semantics. */
        head.setAttribute('role', 'presentation');
        head.innerHTML = '<span class="AcSchedDay__Label"></span>';
        head.firstChild.textContent = label;
        list.insertBefore(head, row);
        lastKey = dayKey;
      }
    });

    var zoneLabel = document.querySelector('[data-ac-tz-label]');
    if (zoneLabel) zoneLabel.textContent = 'times shown in your time zone (' + zone + ')';
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
